import apiEndPoints from '../utils/ctxUtil';
import { adalApiFetch } from '../adalConfig';
import { toast } from 'react-toastify';

export function lossPreventionSettingsLoading(value) {
  return {
    type: 'LOSS_PREVENTION_SETTINGS_LOADING',
    isLoading: value,
  };
}

export function lossPreventionSettingsSaving(value) {
  return {
    type: 'LOSS_PREVENTION_SETTINGS_SAVING',
    isSaving: value,
  };
}

export function lossPreventionSettingsFetchResult(value) {
  return {
    type: 'LOSS_PREVENTION_SETTINGS_FETCH_RESULT',
    data: value,
  };
}

export function lossPreventionSettingsHasErrored(value) {
  return {
    type: 'LOSS_PREVENTION_SETTINGS_HAS_ERRORED',
    hasErrored: value,
  };
}

export function getLossPreventionSettings() {
  const url = apiEndPoints.LOSS_PREVENTION_SETTINGS;

  return (dispatch) => {
    dispatch(lossPreventionSettingsLoading(true));
    adalApiFetch(fetch, url, {})
      .then((response) => {
        if (!response.ok) {
          throw response;
        }

        return response;
      })
      .then((response) => response.json())
      .then((model) => dispatch(lossPreventionSettingsFetchResult(model)))
      .catch((error) => {
        dispatch(lossPreventionSettingsHasErrored(true));
        toast.error(error || 'An error occurred');
      });
  };
}

export function saveLossPreventionSettings(data) {
  const url = apiEndPoints.LOSS_PREVENTION_SETTINGS;

  return (dispatch) => {
    dispatch(lossPreventionSettingsSaving(true));
    adalApiFetch(fetch, url, {
      method: 'PUT',
      mode: 'cors',
      cache: 'no-cache',
      body: JSON.stringify(data),
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        dispatch(lossPreventionSettingsSaving(false));
        dispatch(lossPreventionSettingsFetchResult(data));

        switch (response.status) {
          case 202: {
            dispatch(() => toast.success('Data saved successfully'));
            break;
          }

          case 422: {
            response.json().then((error) => {
              // work-around for IE 11
              const ObjectValues = function values(object) {
                return Object.keys(object).map((key) => object[key]);
              };

              // IE 11 does not support Object.Values
              const items = Object.values
                ? Object.values(error)
                : ObjectValues(error);
              const message = items.join('; ');
              toast.error(message || 'An error occurred');
            });
            break;
          }
          default:
            throw response;
        }
      })
      .catch((error) => toast.error(error.message || 'An error occurred'));
  };
}
